namespace RedBullMOBILE360.SalesApp {
    export interface WalletTransferForm {
        FromPartner: Serenity.IntegerEditor;
        ToAgent: Serenity.IntegerEditor;
        Amount: Serenity.DecimalEditor;
        TransDate: Serenity.DateEditor;
        TransferBy: Serenity.IntegerEditor;
        PartnerBalanceBefore: Serenity.DecimalEditor;
        PartnerBalanceAfter: Serenity.DecimalEditor;
        SellerBalanceBefore: Serenity.DecimalEditor;
        SellerBalanceAfter: Serenity.DecimalEditor;
        TransferType: Serenity.IntegerEditor;
        ReferenceNo: Serenity.StringEditor;
    }

    export class WalletTransferForm extends Serenity.PrefixedContext {
        static formKey = 'SalesApp.WalletTransfer';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!WalletTransferForm.init)  {
                WalletTransferForm.init = true;

                var s = Serenity;
                var w0 = s.IntegerEditor;
                var w1 = s.DecimalEditor;
                var w2 = s.DateEditor;
                var w3 = s.StringEditor;

                Q.initFormType(WalletTransferForm, [
                    'FromPartner', w0,
                    'ToAgent', w0,
                    'Amount', w1,
                    'TransDate', w2,
                    'TransferBy', w0,
                    'PartnerBalanceBefore', w1,
                    'PartnerBalanceAfter', w1,
                    'SellerBalanceBefore', w1,
                    'SellerBalanceAfter', w1,
                    'TransferType', w0,
                    'ReferenceNo', w3
                ]);
            }
        }
    }
}
